// 等待路由异步组件及页签渲染，只定位已有可见内容，不调用业务按钮。
export function locateFunctionTarget(focus:string):()=>void {
 let timer:ReturnType<typeof setTimeout>,highlight:Element|undefined
 const finish=()=>{observer.disconnect();clearTimeout(timer)}
 const find=()=>{
  const explicit=Array.from(document.querySelectorAll('[data-function-focus]')).find(el=>el.getAttribute('data-function-focus')===focus)
  const candidates=explicit?[explicit]:Array.from(document.querySelectorAll('.ant-form-item-label label,button,.ant-btn,h2,h3')).filter(el=>el.textContent?.trim().replace(/[:：]$/,'')===focus)
  const target=candidates.find(el=>el.getClientRects().length>0) as HTMLElement|undefined
  if(!target)return
  highlight=target;target.scrollIntoView({block:'center',behavior:'smooth'});target.classList.add('function-search-highlight');finish();timer=setTimeout(()=>target.classList.remove('function-search-highlight'),3500)
 }
 const observer=new MutationObserver(find);observer.observe(document.body,{childList:true,subtree:true});timer=setTimeout(finish,8000);find()
 return()=>{finish();highlight?.classList.remove('function-search-highlight')}
}
